import './offer-type-label.css';
